import React from 'react';
import icon from 'images/icons/big9/crown-with-border.svg';

import '../styles/group.css';
import useScreens, {
    POOL_LIST_SLUG,
} from 'features/SpilKlub/screens/useScreens';
import GroupAvatar from 'features/SpilKlub/components/GroupAvatar';
import Text from '../../../ui/Text';

const Group = ({ group, expertGroup = false }) => {
    const { setScreen } = useScreens();
    return (
        <div
            className="group-container top-indent-md"
            onClick={() => {
                setScreen(POOL_LIST_SLUG, group.poolTemplateId);
            }}
        >
            <div className="group-avatar-wrapper">
                <GroupAvatar
                    groupName={group.name}
                    avatarUrl={group?.avatarUrl ? `${group?.avatarUrl}` : ''}
                />
                {expertGroup && (
                    <img className="group-icon" src={icon} alt="icon-top" />
                )}
            </div>
            <div className="group-info">
                <div className="group-info-top">
                    <Text
                        margin={'0'}
                        padding={'0'}
                        size={'16'}
                        lh={'19'}
                        bold
                        color={'#333'}
                    >
                        {group.name}
                    </Text>
                    <p className="group-text hyphens">{group?.description}</p>
                </div>

                <div className="group-info-bottom">
                    {group.activePools.length ? (
                        <div className="group-info-bottom">
                            <span className="group-block">
                                Andele {group?.totalBoughtSharesNumber} af{' '}
                                {group?.settings?.sharesLimit}
                            </span>
                            <span className="group-block">
                                {group?.settings?.sharePrice} kr.
                            </span>
                            {group?.userBoughtSharesNumber > 0 && (
                                <span className="group-block group-block-sold-out">
                                    Købt
                                </span>
                            )}
                        </div>
                    ) : (
                        <span className="group-block">Ingen aktive spil</span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Group;
